import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { IAppointments } from "../../shared/interfaces/schedulePage";
import { dateFormatter } from "@/utils/dateFormatter";
import { getSheduleData } from "@/services/API/shedule";
import { toast } from "react-toastify";

import { setLoading } from "../ui/ui";

export const fetchSchedule = createAsyncThunk(
    "schedule/fetchSchedule",
    async (_, thunkAPI) => {
        const state = thunkAPI.getState() as { schedule: IAppointments };
        const date = state.schedule.globalDate;

        try {
            thunkAPI.dispatch(setLoading(true));
            const response = await getSheduleData(
                typeof date === "string" ? date : dateFormatter(date),
            );
            if ("error" in response) {
                return thunkAPI.rejectWithValue(response.error);
            }
            thunkAPI.dispatch(setLoading(false));
            return response;
        } catch (err) {
            thunkAPI.dispatch(setLoading(false));
            return thunkAPI.rejectWithValue("Не вдалося отримати розклад");
        }
    },
);

const initialState: IAppointments = {
    schedule: [],
    globalDate: dateFormatter(new Date()),
    appointmentId: "",
};

const scheduleSlice = createSlice({
    name: "schedule",
    initialState,
    reducers: {
        addAppointment: (state, action) => {
            state.schedule = [...state.schedule, action.payload];
        },
        setSheduleDate: (state, action) => {
            state.schedule = [...action.payload];
        },
        setAppointemtId: (state, action) => {
            state.appointmentId = action.payload;
        },
        deleteAppointment: (state, action) => {
            state.schedule = state.schedule.filter(
                app => app._id !== action.payload,
            );
        },
        updateSchedule: (state, action) => {
            const updatedAppointment = action.payload;
            state.schedule = state.schedule.map(appointment =>
                appointment._id ===
                (updatedAppointment.id ?? updatedAppointment._id)
                    ? updatedAppointment
                    : appointment,
            );
        },
        setGlobalDate: (state, action) => {
            state.globalDate = action.payload;
        },
        updatePayment: (state, action) => {
            const { id, paymentHistory } = action.payload;
            state.schedule = state.schedule.map(appointment =>
                appointment._id === id
                    ? {
                          ...appointment,
                          paymentHistory: [...paymentHistory],
                      }
                    : appointment,
            );
        },
        updateAppointmentComplete: (state, action) => {
            const { _id, isAppointmentComplete } = action.payload;
            state.schedule = state.schedule.map(appointment =>
                appointment._id === _id
                    ? {
                          ...appointment,
                          isAppointmentComplete,
                      }
                    : appointment,
            );
        },
        updateHasVisitedAppointment: (state, action) => {
            const { _id, isChecked } = action.payload;
            state.schedule = state.schedule.map(appointment =>
                appointment._id === _id
                    ? {
                          ...appointment,
                          hasVisited: isChecked,
                      }
                    : appointment,
            );
        },
        updateServices: (state, action) => {
            const { _id, services } = action.payload;
            state.schedule = state.schedule.map(appointment =>
                appointment._id === _id
                    ? {
                          ...appointment,
                          services: services,
                      }
                    : appointment,
            );
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchSchedule.fulfilled, (state, action) => {
                state.schedule = [...action.payload.data];
            })
            .addCase(fetchSchedule.rejected, (state, action) => {
                const errorMessage =
                    (action.payload as string) || "Сталася невідома помилка";
                toast.error("Помилка при отриманні розкладу: " + errorMessage);
            });
    },
});

export const {
    addAppointment,
    deleteAppointment,
    updateSchedule,
    setGlobalDate,
    updatePayment,
    setSheduleDate,
    setAppointemtId,
    updateAppointmentComplete,
    updateHasVisitedAppointment,
    updateServices,
} = scheduleSlice.actions;
export default scheduleSlice.reducer;
